import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tokenHeaderClientId: '663af63eb9221d6b480883f1',
    clientId: 'yMixaPPYlxOCUwJZpbh4pw',
    clientSecret: 'otBgwZzNfCNtWea0qETd2CYfa2Etf20Pwh7ivmB1tO4',
    applicationId: '66875ecada396f80d50dfc9a',
    platform: "HTML5"
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {}
})
